import { firstValueFrom, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { AccountService } from '@app/_services';

export function appInitializer(accountService: AccountService) {
    return () => firstValueFrom(
        accountService.refreshToken().pipe(
            timeout(3000),
            catchError(() => of(null))
        )
    );
}